import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";

export default function DestinationCard({ dest, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.06 }}
      className="group relative rounded-3xl overflow-hidden bg-white border border-slate-100 shadow-lg shadow-blue-500/5 hover:shadow-2xl hover:shadow-blue-500/15 hover:-translate-y-1 transition-transform"
      data-testid={`destination-card-${dest.slug}`}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={dest.hero_image}
          alt={dest.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/10 to-transparent" />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 rounded-full bg-white/90 backdrop-blur text-xs font-bold text-slate-900 uppercase tracking-wider">
            {dest.name}
          </span>
        </div>
        <div className="absolute bottom-4 left-4 right-4">
          <p className="text-white text-sm font-medium">{dest.tagline}</p>
        </div>
      </div>

      <div className="p-6">
        <p className="text-sm text-slate-600 leading-relaxed line-clamp-3 mb-4">
          {dest.short_description}
        </p>

        {dest.available_from?.length ? (
          <div className="mb-5">
            <p className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2">Available from</p>
            <div className="flex flex-wrap gap-1.5">
              {dest.available_from.slice(0, 6).map((c) => (
                <span key={c} className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-slate-100 text-[11px] font-medium text-slate-600">
                  <MapPin className="w-3 h-3" />
                  {c}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        <Link
          to={`/destinations/${dest.slug}`}
          data-testid={`destination-explore-${dest.slug}`}
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#D52B1E] hover:text-[#A31E13] group/link"
        >
          Explore {dest.name} Programs
          <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
        </Link>
      </div>
    </motion.article>
  );
}
